import { Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-home-unauthorization',
  templateUrl: './home-unauthorization.component.html',
  styleUrls: ['./home-unauthorization.component.scss']
})
export class HomeUnauthorizationComponent {

  constructor() { }

}
